import { render, staticRenderFns } from "./Mini_HomePopup.vue?vue&type=template&id=0fdaa97a&scoped=true&"
import script from "./Mini_HomePopup.vue?vue&type=script&lang=js&"
export * from "./Mini_HomePopup.vue?vue&type=script&lang=js&"
import style0 from "./Mini_HomePopup.vue?vue&type=style&index=0&id=0fdaa97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdaa97a",
  null
  
)

export default component.exports